<template>
  <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl mx-auto">
      <form @submit.prevent="update">
        <!-- Form inputs remain the same -->
        <div class="p-6 sm:p-8 -mr-6 -mb-6 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-6 w-full lg:w-1/2"
            :label="__('Name')" :disabled="!user_access.category.update" />

          <checkbox-input v-model="form.status" :error="form.errors.status" class="pr-6 pb-6 w-full lg:w-1/2"
            :label="__('Active')" :disabled="!user_access.category.update" />
        </div>

        <div class="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center space-x-2">
          <button v-if="user_access.category.delete" class="text-red-600 hover:underline" tabindex="-1" type="button"
            @click="destroy">
            {{ __('Delete') }}
          </button>

          <Link class="btn-gray" :href="route('faq-categories.cancel')" method="post" as="button" type="button"
            preserve-scroll>
          {{ __('Cancel') }}
          </Link>

          <loading-button :loading="form.processing" class="btn-indigo" type="submit"
            :disabled="!user_access.category.update">
            {{ __('Update') }} {{ __('Category') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import CheckboxInput from '@/Shared/CheckboxInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    LoadingButton,
    CheckboxInput,
    TextInput,
    Link,
    Head,
    Layout
  },
  layout: Layout,
  props: {
    category: Object,
    auth: Object,
  },
  data() {
    return {
      deleting: false,
      user: this.$page.props.auth.user,
      form: this.$inertia.form({
        name: this.category.name,
        status: this.category.status,
      }),
      user_access: this.$page.props.auth.user.access,
    }
  },
  methods: {
    update() {
      this.form.put(route('faq-categories.update', this.category.id), {
        preserveScroll: true,
        onSuccess: () => {
          this.showToast('success', 'FAQ Category updated successfully!')
        }
      })
    },

    destroy() {
      if (confirm('Are you sure you want to delete this category?')) {
        this.$inertia.delete(this.route('faq-categories.destroy', this.category.id))
      }
    },

    showToast(type, message) {
      // Replace with your actual toast implementation
      alert(`${type}: ${message}`) // Temporary for debugging
    }
  }
}
</script>
